import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { axiosClient } from "../../../api/axios-client";
import { RootState } from "../../types";
import CallType from "../types/call-type";

export const getCallToken = createAsyncThunk<
  string, { type: CallType }
>(
  "calls-slice/get-call-token",
  async (
    { type },
    { signal, rejectWithValue, fulfillWithValue, getState }
  ) => {
    const identity = 'user';
    const state = getState() as RootState;
    const callResponse = await axiosClient.post<{room_name: string}>(
      `/call-agent`,
      {
        su_id: state["app-state"].suId,
        session_id: state["app-state"].sessionId,
        conversation_id: state["app-state"].conversationId,
        merch_id: state["app-state"].merchId,
        type,
      },
      {
        signal
      }
    );

    const response = await axiosClient.get<{token: string}>(
      `/twilio/get-token?identity=${identity}&room=${callResponse.data.room_name}`,
      {
        signal
      }
    );

    if (response.status !== HttpStatusCode.Ok) {
      return rejectWithValue((response.data));
    }

    return fulfillWithValue(response.data.token);
  }
);
